"use strict";
// NB: Start all routes must follow:
// - forward slash at the beginning
// - lowercase words
// - using dashes(hyphens) for multiple words
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTIONS_REWARD_TRACK_CONFIG_ROUTE = exports.TRANSACTIONS_ITEMS_ROUTE = exports.TRANSACTIONS_CHALLLENGE_CONFIGS_ROUTE = exports.TRANSACTIONS_ECO_CONFIGS_ROUTE = exports.ECO_STATISTIC_CONFIGS_ROUTE = exports.ECO_CURRENCY_CONFIGS_ROUTE = exports.ECO_CURRENCIES_ROUTE = exports.REWARD_TRACKS_ROUTE = exports.SEGMENTS_ROUTE = exports.LEADERBOARDS_ROUTE = exports.STATISTICS_ROUTE = exports.EVENT_TYPES_ROUTE = exports.CHALLENGES_ROUTE = exports.ITEM_BADGES_ROUTE = exports.ITEMS_ROUTE = exports.USER_ROLE_ROUTE = exports.USER_ROLES_ROUTE = exports.USERS_ROUTE = exports.CUSTOMERS_ROUTE = exports.NEW_ROUTE = exports.SETTINGS_ROUTE = exports.DASHBOARD_ROUTE = exports.CONSOLE_ROUTE = exports.SELECT_SUBSCRIPTION_ROUTE = exports.PRIVACY_POLICY_ROUTE = exports.TERMS_AND_CONDITIONS_ROUTE = exports.RESET_PASSWORD_ROUTE = exports.FORGOT_PASSWORD_ROUTE = exports.CREATE_CLIENT_ROUTE = exports.SIGN_UP_ROUTE = exports.LOG_IN_ROUTE = exports.WELCOME_ROUTE = void 0;
// Every entity is addressed the same way: the plural is the list, `/:id` is one record,
// and `/new` is the create form. There are no singular sibling routes.
// ENTRY ROUTES >
var WELCOME_ROUTE = "/welcome";
exports.WELCOME_ROUTE = WELCOME_ROUTE;
var LOG_IN_ROUTE = "/log-in";
exports.LOG_IN_ROUTE = LOG_IN_ROUTE;
var SIGN_UP_ROUTE = "/sign-up";
exports.SIGN_UP_ROUTE = SIGN_UP_ROUTE;
var CREATE_CLIENT_ROUTE = "/create-client";
exports.CREATE_CLIENT_ROUTE = CREATE_CLIENT_ROUTE;
var FORGOT_PASSWORD_ROUTE = "/forgot-password";
exports.FORGOT_PASSWORD_ROUTE = FORGOT_PASSWORD_ROUTE;
var RESET_PASSWORD_ROUTE = "/reset-password";
exports.RESET_PASSWORD_ROUTE = RESET_PASSWORD_ROUTE;
var TERMS_AND_CONDITIONS_ROUTE = "/terms-and-conditions";
exports.TERMS_AND_CONDITIONS_ROUTE = TERMS_AND_CONDITIONS_ROUTE;
var PRIVACY_POLICY_ROUTE = "/privacy-policy";
exports.PRIVACY_POLICY_ROUTE = PRIVACY_POLICY_ROUTE;
var SELECT_SUBSCRIPTION_ROUTE = "/select-subscription";
exports.SELECT_SUBSCRIPTION_ROUTE = SELECT_SUBSCRIPTION_ROUTE;
// CONSOLE ROUTES >
var CONSOLE_ROUTE = "/console";
exports.CONSOLE_ROUTE = CONSOLE_ROUTE;
var DASHBOARD_ROUTE = "/dashboard";
exports.DASHBOARD_ROUTE = DASHBOARD_ROUTE;
var SETTINGS_ROUTE = "/settings";
exports.SETTINGS_ROUTE = SETTINGS_ROUTE;
// appended to any list route to reach its create form
var NEW_ROUTE = "/new";
exports.NEW_ROUTE = NEW_ROUTE;
var CUSTOMERS_ROUTE = "/customers";
exports.CUSTOMERS_ROUTE = CUSTOMERS_ROUTE;
var USERS_ROUTE = "/users";
exports.USERS_ROUTE = USERS_ROUTE;
var USER_ROLES_ROUTE = "/roles";
exports.USER_ROLES_ROUTE = USER_ROLES_ROUTE;
var USER_ROLE_ROUTE = "/role";
exports.USER_ROLE_ROUTE = USER_ROLE_ROUTE;
var ITEMS_ROUTE = "/items";
exports.ITEMS_ROUTE = ITEMS_ROUTE;
var ITEM_BADGES_ROUTE = "/items/badges";
exports.ITEM_BADGES_ROUTE = ITEM_BADGES_ROUTE;
var CHALLENGES_ROUTE = "/challenges";
exports.CHALLENGES_ROUTE = CHALLENGES_ROUTE;
var EVENT_TYPES_ROUTE = "/event-types";
exports.EVENT_TYPES_ROUTE = EVENT_TYPES_ROUTE;
var STATISTICS_ROUTE = "/statistics";
exports.STATISTICS_ROUTE = STATISTICS_ROUTE;
var LEADERBOARDS_ROUTE = "/leaderboards";
exports.LEADERBOARDS_ROUTE = LEADERBOARDS_ROUTE;
var SEGMENTS_ROUTE = "/segments";
exports.SEGMENTS_ROUTE = SEGMENTS_ROUTE;
var REWARD_TRACKS_ROUTE = "/reward-tracks";
exports.REWARD_TRACKS_ROUTE = REWARD_TRACKS_ROUTE;
var ECO_CURRENCIES_ROUTE = "/economics/currencies";
exports.ECO_CURRENCIES_ROUTE = ECO_CURRENCIES_ROUTE;
var ECO_CURRENCY_CONFIGS_ROUTE = "/economics/cashback-configs";
exports.ECO_CURRENCY_CONFIGS_ROUTE = ECO_CURRENCY_CONFIGS_ROUTE;
var ECO_STATISTIC_CONFIGS_ROUTE = "/economics/xp-configs";
exports.ECO_STATISTIC_CONFIGS_ROUTE = ECO_STATISTIC_CONFIGS_ROUTE;
var TRANSACTIONS_ECO_CONFIGS_ROUTE = "/economics/transactions";
exports.TRANSACTIONS_ECO_CONFIGS_ROUTE = TRANSACTIONS_ECO_CONFIGS_ROUTE;
var TRANSACTIONS_CHALLLENGE_CONFIGS_ROUTE = "/transactions/challenges";
exports.TRANSACTIONS_CHALLLENGE_CONFIGS_ROUTE = TRANSACTIONS_CHALLLENGE_CONFIGS_ROUTE;
var TRANSACTIONS_ITEMS_ROUTE = "/transactions/items";
exports.TRANSACTIONS_ITEMS_ROUTE = TRANSACTIONS_ITEMS_ROUTE;
var TRANSACTIONS_REWARD_TRACK_CONFIG_ROUTE = "/transactions/reward-tracks";
exports.TRANSACTIONS_REWARD_TRACK_CONFIG_ROUTE = TRANSACTIONS_REWARD_TRACK_CONFIG_ROUTE;
